import { FunctionComponent } from "react";
import { LL0 } from "@/react/core/I18nService.tsx";

export type IsEmptyType = {
  className?: string;
};

const IsEmpty: FunctionComponent<IsEmptyType> = ({ className = "" }) => {
  return (
    <div
      className={`self-stretch flex-[0.8828] flex flex-col items-center justify-center py-[24px] px-[12px] gap-[16px] text-center text-[14px] text-[#212121] font-[Mulish] ${className}`}
    >
      <img
        className="w-[88px] relative h-[88px] object-cover"
        alt=""
        src="/iconempty-warning@2x.png"
      />
      <div className="self-stretch relative leading-[140%]">
        <p className="m-[0px]">{LL0().deliveryManagement.popupSetAnyDeliveryFees()}</p>
        <p className="m-[0px]">
          <span>Click the '</span>
          <b className="font-[Mulish]">{LL0().deliveryManagement.addNew()}</b>
          <span className="font-[Mulish]">
            {LL0().deliveryManagement.createNewDeliverySetting()}
          </span>
        </p>
      </div>
    </div>
  );
};

export default IsEmpty;
